import { Dropdown } from "react-bootstrap"

interface Props<T> {
    items: Readonly<T[]>
    selectedItems: T[]
    onSelect: (selectedBlocks: T[]) => void
    label: string
    icon?: React.ReactNode
}

const MultiSelectDropdown = <T,>({ items, selectedItems, onSelect, label, icon } : Props<T>) => {

  return (
    <Dropdown className="text-start">
        <Dropdown.Toggle variant="transparent" className="text-theme border rounded border-theme">
            {selectedItems.length === 0 ? 
            <span>{icon} {label}</span> : 
            <span>{selectedItems.length} selected</span>}
        </Dropdown.Toggle>
        <Dropdown.Menu style={{ zIndex: 1050 }}>
            <Dropdown.Item
                onClick={(e) => {
                    e.stopPropagation()
                    const allSelected = selectedItems.length === items.length
                    const newSelectedItems = allSelected ? [] : [...items]
                    onSelect(newSelectedItems)
                }}>
                <input
                    readOnly
                    type="checkbox"
                    checked={selectedItems.length === items.length}
                    className="pe-none"
                />
                <span className="ps-3">Select All</span>
            </Dropdown.Item>
            {items.map(item => {
                return <Dropdown.Item
                        onClick={(e) => {
                            e.stopPropagation()
                            const newSelectedItems = selectedItems.includes(item) ? selectedItems.filter(i => i !== item) : [...selectedItems, item]
                            onSelect(newSelectedItems)
                        }}
                    >
                        <input
                            readOnly
                            type="checkbox"
                            checked={selectedItems.includes(item)}
                            className="pe-none"
                        />
                        <span className="ps-3">{item}</span>
                    </Dropdown.Item>
            })}
        </Dropdown.Menu>
    </Dropdown>
  )
}

export default MultiSelectDropdown
